import React from 'react';
import { useSelector, } from 'react-redux';

import { MeStateType, ReactChildrenUtil, } from 'common/types';
import { isLoggedSelector, } from 'common/selectors';

type Props = ReactChildrenUtil & {};

const IsLogged: React.FC<Props> = ({ children, }) => {
    const isLogged = useSelector<MeStateType, boolean>(isLoggedSelector);

    return isLogged && children;
};

export default IsLogged;
